var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19571 4.02722C6.07073 4.15224 6.00052 4.32178 6.00052 4.49856C6.00052 4.67533 6.07073 4.84487 6.19571 4.96989L9.72438 8.49856L6.19571 12.0272C6.13204 12.0887 6.08125 12.1623 6.04631 12.2436C6.01137 12.325 5.99298 12.4124 5.99221 12.501C5.99144 12.5895 6.00831 12.6773 6.04183 12.7592C6.07535 12.8411 6.12486 12.9156 6.18745 12.9782C6.25005 13.0407 6.32448 13.0903 6.40641 13.1238C6.48834 13.1573 6.57613 13.1742 6.66465 13.1734C6.75317 13.1726 6.84065 13.1542 6.92198 13.1193C7.00332 13.0844 7.07688 13.0336 7.13838 12.9699L11.1384 8.96989C11.2634 8.84487 11.3336 8.67533 11.3336 8.49856C11.3336 8.32178 11.2634 8.15224 11.1384 8.02722L7.13838 4.02722C7.01336 3.90224 6.84382 3.83203 6.66705 3.83203C6.49027 3.83203 6.32073 3.90224 6.19571 4.02722Z",
    fill: "#696974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.e7e6492d15a114391cbdc99bddaae082.svg";
export { ForwardRef as ReactComponent };